import useRollbarUtil from "@/components/hooks/useRollbarUtil";
import { AuthContext, AuthStatus } from "@/contexts/AuthContext";
import { useCompanyQuery } from "@/generated/graphql_billing";
import { APIContext } from "@/libs/constants";
import { useContext, useMemo } from "react";

export const useCompany = () => {
  const { getNotifyErrorHandlerForGraphQL } = useRollbarUtil();

  const { authStatus, userInfo } = useContext(AuthContext);

  const { loading, data, refetch } = useCompanyQuery({
    // Skip until signed in — prevents spurious error notifications on pages
    // that render before useCheckAuth's redirect effect runs.
    skip: authStatus !== AuthStatus.SignedIn,
    onError: getNotifyErrorHandlerForGraphQL("Failed to get company"),
    context: {
      api: APIContext.BILLING,
    },
  });

  const companyLoading = useMemo(() => {
    return authStatus === AuthStatus.Loading || loading;
  }, [authStatus, loading]);

  const company = useMemo(() => data?.company, [data]);

  const isAdmin = useMemo(() => {
    return !!data?.company.admins.find(
      (admin) => admin.userSub === userInfo?.sub
    );
  }, [data]);

  return {
    company,
    companyLoading,
    companyRefetch: refetch,
    isAdmin,
  };
};
